import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { LoadData, PrintBill, ExportDetailData as _ExportDetailData, GetLastById, GetNextById, GetVendorEmail } from '@/api/Outsourced';
import { SendEmail } from '@/api/SendMail';
import util from '@/libs/util';
import { GetReportID as _GetReportID } from '@/api/SysReportTpl';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  mixins: [ExportListMixin],
  mounted: function mounted() {
    this.GetReportID();
  },
  data: function data() {
    return {
      formData: {
        DELIVERY_NO: null,
        // 送货单号
        CREATORID: null,
        // 制单人
        DESCRIPTION: null,
        // 备注
        DELIVERY_DATE: null,
        // 出货日期
        VENDOR_CODE: null,
        // 供应商代码
        ARRIVAL_DATE: null,
        // 到货日期
        STATUS_Caption: null // 单据状态

      },
      submitData: {},
      mode: 'show',
      templateID: null,
      userInfo: JSON.parse(util.cookies.get('userInfo'))
    };
  },
  methods: {
    // 通过ID获取单据信息
    asyncData: function asyncData(ID) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res, row;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    ID: ID
                  }
                };
                console.log('TabelHeaderForEdit params', params);
                _context.next = 4;
                return LoadData(params);

              case 4:
                res = _context.sent;
                console.log('TabelHeaderForEdit 通过ID获取单据信息', res);

                if (res.code === 0) {
                  if (res.data.Items.length > 0) {
                    row = res.data.Items[0];

                    _this.setData(row);
                  } else {
                    _this.$message.warning('获取单据信息失败');
                  }
                } else {
                  _this.$message.warning('res.message');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getVENDOR_CODE: function getVENDOR_CODE() {
      this.$emit('cbVENDOR_CODE', this.formData.VENDOR_CODE);
    },
    // 导出明细
    ExportDetailData: function ExportDetailData() {
      console.log('this.submitData', this.submitData);
      var ID = this.submitData.ID;
      var ORGANIZE_ID = util.cookies.get('ORG_ID');
      var EXPORT_FILE_NAME = '委外送货单明细';
      this.$message.success('已添加到 导出列表 中');
      this.setUnreadExportMessionNum();

      _ExportDetailData({
        ID: ID,
        ORGANIZE_ID: ORGANIZE_ID,
        EXPORT_FILE_NAME: EXPORT_FILE_NAME
      }); // this.$openLoading()
      // const res = await ExportDetailData({ ID, ORGANIZE_ID })
      // this.$closeLoading()
      // console.log(res)
      // if (res.code === 0) {
      //   window.open(this.$store.getters.getVUE_APP_DOWN + res.data)
      // } else {
      //   this.$message.warning('数据导出失败----' + res.message)
      // }

    },
    // 修改单据保存
    handleSave: function handleSave() {
      // console.log('修改保存');
      // console.log('出货日期', new Date(Date.parse(this.formData.DELIVERY_DATE)));
      // console.log('到货日期',Date.parse(this.formData.ARRIVAL_DATE) );
      if (Date.parse(this.formData.ARRIVAL_DATE) < Date.parse(this.formData.DELIVERY_DATE)) {
        this.$message.warning('到货日期不能少于出货日期');
      } else {
        // console.log('this.formData',this.formData);
        // console.log(new Date(Date.parse(this.formData.DELIVERY_DATE)));
        // console.log('this.submitData',this.submitData);
        // this.submitData.DELIVERY_DATE = new Date(Date.parse(this.formData.DELIVERY_DATE))
        // this.submitData.ARRIVAL_DATE = new Date(Date.parse(this.formData.ARRIVAL_DATE))
        this.submitData.DELIVERY_DATE = this.formData.DELIVERY_DATE;
        this.submitData.ARRIVAL_DATE = this.formData.ARRIVAL_DATE;
        this.submitData.DESCRIPTION = this.formData.DESCRIPTION; // console.log(this.formData.DELIVERY_DATE);
        // console.log(this.formData.ARRIVAL_DATE);
        // this.Bus.emit('onBeforeSaveEditOrder',this.submitData)

        this.$emit('onBeforeSaveEditOrder', this.submitData);
      }
    },
    // 设置数据
    setData: function setData(data) {
      this.formData.DELIVERY_NO = data.DELIVERY_NO;
      this.formData.CREATORID = data.CREATORID;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.DELIVERY_DATE = util.formatTime.transCommDate(data.DELIVERY_DATE);
      this.formData.VENDOR = data.VENDOR_NAME;
      this.formData.ARRIVAL_DATE = util.formatTime.transCommDate(data.ARRIVAL_DATE);
      this.formData.STATUS_Caption = data.STATUS_Caption;
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.ID = data.ID;
      this.submitData = JSON.parse(JSON.stringify(data));
    },
    handleARRIVAL_DATE: function handleARRIVAL_DATE(v) {
      // console.log('now',new Date());
      // console.log(new Date() < v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：到货日期早于当前系统日期');
      }
    },
    handleDay: function handleDay(v) {
      // console.log(v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：出货日期早于当前系统日期');
      }
    },
    // 上一张单据更新数据
    getBackUpdata: function getBackUpdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.formData);
                params = {
                  mst_id: _this2.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context2.next = 4;
                return GetNextById(params);

              case 4:
                res = _context2.sent;
                console.log('上一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this2.setData(res.data);

                    _this2.$emit('cbNextOrder', res.data.ID, res.data.STATUS);
                  } else {
                    _this2.$message.warning('当前单据已为最前单据');
                  }
                } else {
                  _this2.$message.warning('切换上一张单据失败');
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 下一张单据更新数据
    nextOrderUpdata: function nextOrderUpdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(_this3.formData);
                params = {
                  mst_id: _this3.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context3.next = 4;
                return GetLastById(params);

              case 4:
                res = _context3.sent;
                console.log(res);

                if (res.code === 0) {
                  if (res.data) {
                    _this3.setData(res.data);

                    _this3.$emit('cbNextOrder', res.data.ID, res.data.STATUS);
                  } else {
                    _this3.$message.warning('当前单据已为最后单据');
                  }
                } else {
                  _this3.$message.warning('切换下一张单据失败');
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 打印单据
    PrintOrder: function PrintOrder() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res, token, dataurl, dxurl, url;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.templateID) {
                  _context4.next = 3;
                  break;
                }

                _this4.$message({
                  showClose: true,
                  message: _this4.$t('找不到条码打印模板！'),
                  type: 'warning'
                });

                return _context4.abrupt("return");

              case 3:
                params = {
                  id: _this4.submitData.ID,
                  orG_CODE: util.cookies.get('ORG_CODE'),
                  organizE_ID: util.cookies.get('ORG_ID'),
                  operator: _this4.userInfo.USER_NAME
                };
                _context4.next = 6;
                return PrintBill(params);

              case 6:
                res = _context4.sent;

                if (res.code === 0) {
                  _this4.updataStatus(); // console.log('点击打印');
                  // console.log(this.submitData.ID);


                  token = util.cookies.get('token');
                  dataurl = process.env.VUE_APP_API + "/DeliveryNote/GetBillRptDataByID?mst_id=".concat(_this4.submitData.ID);
                  dxurl = _this4.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
                  url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(_this4.templateID, "&Token=").concat(token); // console.log(url);

                  util.open(url);
                } else {
                  _this4.$message.warning('打印失败');
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 获取打印模板id
    GetReportID: function GetReportID() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  billtype: 'scmDn'
                };
                _context5.next = 3;
                return _GetReportID(params);

              case 3:
                res = _context5.sent;
                console.log('模板id', res);

                if (res.code === 0) {
                  _this5.templateID = res.data;
                } else {
                  _this5.$message.warning('获取打印模板失败');
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 更新表头
    updataStatus: function updataStatus(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('更新表头', id);
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    DELIVERY_NO: id || _this6.formData.DELIVERY_NO
                  }
                };
                _context6.next = 4;
                return LoadData(params);

              case 4:
                res = _context6.sent;

                if (res.code === 0) {
                  _this6.formData.DELIVERY_NO = res.data.Items[0].DELIVERY_NO;
                  _this6.formData.CREATORID = res.data.Items[0].CREATORID;
                  _this6.formData.DESCRIPTION = res.data.Items[0].DESCRIPTION;
                  _this6.formData.VENDOR = res.data.Items[0].VENDOR_NAME; // this.formData.DELIVERY_DATE = res.data.Items[0].DELIVERY_DATE
                  // this.formData.ARRIVAL_DATE = res.data.Items[0].ARRIVAL_DATE

                  _this6.formData.DELIVERY_DATE = util.formatTime.transCommDate(res.data.Items[0].DELIVERY_DATE);
                  _this6.formData.ARRIVAL_DATE = util.formatTime.transCommDate(res.data.Items[0].ARRIVAL_DATE);
                  _this6.formData.STATUS_Caption = res.data.Items[0].STATUS_Caption;
                  _this6.formData.VENDOR_CODE = res.data.Items[0].VENDOR_CODE;
                  _this6.submitData = JSON.parse(JSON.stringify(res.data.Items[0]));
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 邮件发送
    mailSend: function mailSend() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this7$formData, ID, DELIVERY_NO, VENDOR, res, formData, emailParams, key;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7$formData = _this7.formData, ID = _this7$formData.ID, DELIVERY_NO = _this7$formData.DELIVERY_NO, VENDOR = _this7$formData.VENDOR;

                _this7.$openLoading('邮件发送中...');

                _context7.next = 4;
                return GetVendorEmail({
                  mst_id: ID
                });

              case 4:
                res = _context7.sent;

                if (res.data) {
                  formData = new FormData();
                  emailParams = {
                    Recipient: res.data,
                    MailTitle: "".concat(DELIVERY_NO),
                    MailBody: "\u65B0\u589E\u6216\u4FEE\u6539\u9001\u8D27\u5355\uFF0C\u4F9B\u5E94\u5546\uFF1A".concat(VENDOR, "\uFF0C\u5355\u53F7\uFF1A").concat(DELIVERY_NO, "\uFF0C\u67E5\u770B\u660E\u7EC6\u8BF7\u70B9\u51FB\u4EE5\u4E0B\u94FE\u63A5<br/> ").concat(window.location.href, "<br/><br>\u8BF7\u53CA\u65F6\u8FDB\u884C\u5904\u7406\uFF0C\u8C22\u8C22\uFF01<br/><br/> SCM"),
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  };

                  for (key in emailParams) {
                    formData.append(key, emailParams[key]);
                  }

                  SendEmail(formData).then(function (emailRes) {
                    _this7.$closeLoading();

                    if (emailRes.code === 0) {
                      _this7.$message.success('邮件发送成功');
                    } else {
                      _this7.$message.error(emailRes.message);
                    }
                  }).catch(function (err) {
                    _this7.$closeLoading();

                    _this7.$message.error(err);
                  });
                } else {
                  _this7.$message.warning(res.message || '没有设置邮箱');

                  _this7.$closeLoading();
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  watch: {
    $OutsourcedState: {
      handler: function handler(nawValue) {
        // console.log('表头 单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'orderShow') {
          this.mode = 'show'; // this.getOrderData()
        } else if (nawValue === 'listShow') {
          for (var key in this.formData) {
            this.formData[key] = null;
          }
        } else {
          this.mode = 'edit';
        }
      },
      immediate: true
    }
  }
};